import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class TypeMaterielService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/type-materiel/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/type-materiel/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/type-materiel/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/type-materiel/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/type-materiel/delete/${id}`), callback);
   

}